<div class="modal-body scroll-panel w-100-p h-adjust-px" ><!--h-adjust-px Esto debemos ponerlo por una variable que tome los px y se pongan px-->

    <div class="scroll-panel h-100-p">

        <!-- Data -->
        <div>
            <form [formGroup]="fmCompany" autocomplete="off" class="mt-4">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block border-blue-8-radius">
                            <mat-label>
                                {{ 'companies.lblCompanyKey' | translate }}
                            </mat-label>
                            <input matInput maxlength="10" [formControl]="fmDet.txtCode" >
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block border-blue-8-radius">
                            <mat-label>
                                {{ 'companies.lblCompanyName' | translate }}
                            </mat-label>
                            <input matInput maxlength="80" [formControl]="fmDet.txtName" >
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block border-blue-8-radius">
                            <mat-label>
                                {{ 'companies.lblRFC' | translate }}
                            </mat-label>
                            <input matInput maxlength="13" [formControl]="fmDet.txtRFC" >
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block border-blue-8-radius">
                            <mat-label>{{ 'companies.lblContactName' | translate }}</mat-label>
                            <input matInput maxlength="50" [formControl]="fmDet.txtContactName"
                                data-type="notdoublespace" data-valid="notnumber">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block border-blue-8-radius">
                            <mat-label>
                                {{ 'companies.lblContactEmail' | translate }}
                            </mat-label>
                            <input matInput maxlength="40" [formControl]="fmDet.txtContactEmail">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="d-block border-blue-8-radius">
                            <mat-label>
                                {{ 'companies.lblUserName' | translate }}
                            </mat-label>
                            <input matInput maxlength="40" [formControl]="fmDet.txtUserId">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label class="d-block lbl-radios">
                                {{ 'common.lblStatus' | translate }}
                            </label>
                            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                                [formControl]="fmDet.rbStatusId">
                                <mat-radio-button class="example-radio-button mr-2" *ngFor="let item of catStatus"
                                    [value]="item.value">
                                    {{item.name}}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <hr>

        <!-- Type of identity -->

        <div>
            <form [formGroup]="fmTypePerson" >
                <div class="col-lg-12">
                    <div class="form-group">
                        <!-- IS OK FOR TYPE PERSONS --- IOMC
                        <div class="row mt-2">
                            <input type="checkbox" id="physical" formControlName="chckbxFPerson" [value]="true" class="checkbox-blue-disabled" [checked]="true">
                            &nbsp;<span class="fw-w-bold">{{ 'companies.lblNaturalPerson' | translate }}</span>&nbsp;{{ 'companies.lblNaturalPersonSection' | translate }}
                        </div>
                        <div class="row mt-2">
                            <input type="checkbox" id="moral" formControlName="chckbxMPerson" [value]="false" class="checkbox-blue" [checked]="false">
                            &nbsp;<span class="fw-w-bold">{{ 'companies.lblMoralPerson' | translate }}</span>&nbsp;{{ 'companies.lblMoralPersonSection' | translate }}
                        </div> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <!-- IS OK FOR TYPE PERSONS --- IOMC
                            <hr> -->
                            <ng-container *ngIf="isEnabled">
                                <mat-slide-toggle [ngClass]="'status-obj'" formControlName="mstLightIdentity" [checked]="true"></mat-slide-toggle>
                                &nbsp;
                                <label for="mstLightIdentity">{{ 'companies.lblLightIdentityQuestion' | translate}}</label>
                            </ng-container>
                            <ng-container *ngIf="!isEnabled">
                                <mat-slide-toggle [ngClass]="'status-obj'" formControlName="mstLightIdentity" [checked]="false"></mat-slide-toggle>
                                &nbsp;
                                <label for="mstLightIdentity">{{ 'companies.lblLightIdentityQuestion' | translate}}</label>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <hr>

        <!-- Sections -->
        <div>

            <form autocomplete="off">
                <div class="container-fluid p-2">
                    <div class="modal-header-custom">
                        <div class="flex justify-content-space-between">
                            <span class="fw-bold title-modal-detail fz-14-px">
                                {{ 'companies.lblEnrollmentsSections' | translate }}
                            </span>
                        </div>
                        <hr class="line-h-blue-purple-dialogs">
                    </div>
                    <div class="modal-body body-modal-md">

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="col-lg-12 mb-3">
                                    <i class="fa-brands fa-android text-blue-main mr-2"></i>
                                    <span class="fz-14-px">
                                        {{'companies.lblEnrollmentsAndroid' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12">
                                    <div class="content fz-14-px">
                                        <div *ngFor="let item of this.sectionCat_movil_android">
                                            <mat-checkbox checked="{{item.checked}}" [disabled]="true">
                                                <span class="item-cb-name ml-2 fz-14-px">{{item.name}}:</span>
                                                <span class="item-cb-description ml-2 fz-14-px">{{item.description}}</span>
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="col-lg-12 mb-3">
                                    <i class="fa-brands fa-apple text-blue-main mr-2"></i>
                                    <span class="fz-14-px">
                                        {{'companies.lblEnrollmentsiOS' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12">
                                    <div class="content fz-14-px">
                                        <div *ngFor="let item of this.sectionCat_movil_iOS">
                                            <mat-checkbox checked="{{item.checked}}" [disabled]="true">
                                                <span class="item-cb-name ml-2">{{item.name}}:</span>
                                                <span class="item-cb-description ml-2">{{item.description}}</span>
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="col-lg-12 mb-3">
                                    <i class="fa-solid fa-globe text-blue-main mr-2"></i>
                                    <span class="fz-14-px">
                                        {{'companies.lblEnrollmentsWebResponsive' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12">
                                    <div class="content fz-14-px">
                                        <div *ngFor="let item of this.sectionCat_web_responsive">
                                            <mat-checkbox checked="{{item.checked}}" [disabled]="true">
                                                <span class="item-cb-name ml-2">{{item.name}}:</span>
                                                <span class="item-cb-description ml-2">{{item.description}}</span>
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="col-lg-12 mb-3">
                                    <i class="fa-solid fa-earth-americas text-blue-main mr-2"></i>
                                    <span class="fz-14-px">
                                        {{'companies.lblEnrollmentsWeb' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12">
                                    <div class="content fz-14-px">
                                        <div *ngFor="let item of this.sectionCat_web">
                                            <mat-checkbox checked="{{item.checked}}" [disabled]="true">
                                                <span class="item-cb-name ml-2">{{item.name}}:</span>
                                                <span class="item-cb-description ml-2">{{item.description}}</span>
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-8 col-md-6 col-sm-12">
                                <div class="col-lg-12 pt-2">
                                    <span class="py-2 font-weight-bold fz-14-px">
                                        {{'companies.lblOtherDocuments' | translate | uppercase }}
                                    </span>
                                </div>
                                <div class="col-lg-12 pt-3">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ 'companies.ddlDocuments' | translate }}</mat-label>
                                        <mat-select [formControl]="fmSectionsG.ddlDocuments" enabled="false">
                                            <mat-option *ngFor="let item of this.catDocuments"
                                                value="{{item.value}}">{{item.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>

        <hr>

        <!-- Services -->
        <div>
            <div class="modal-header-custom">
                <div class="flex justify-content-space-between">
                    <span class="fw-bold title-modal-detail fz-14-px">
                        {{ 'companies.lblServices' | translate }}
                    </span>
                </div>
                <hr class="line-h-blue-purple-dialogs">
            </div>

            <div class="row mt-2">
                <div class="col-lg-12">
                    <div class="scroll-panel">
                        <div *ngFor="let item of this.servicesAllCat">
                            <mat-checkbox checked="{{item.checked}}" [disabled]="true" class="ml-3">
                                <span class="item-cb-name ml-2">{{item.name}}:</span>
                                <span class="item-cb-description ml-2">{{item.description}}</span>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 pt-3" *ngIf="this.showDivUrlINE">
                    <form [formGroup]="fmServices" autocomplete="off">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group2">
                                <mat-form-field appearance="outline" class="d-block">
                                    <mat-label>URL servicio INE</mat-label>
                                    <input matInput maxlength="80" [formControl]="fmServicesG.txtUrlINE">
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>

    <ng-container *ngIf="listProviders.length > 0">
        <hr>

        <!-- Providers -->
        <div>
            <div class="modal-header-custom">
                <div class="flex justify-content-space-between">
                    <span class="fw-bold title-modal-detail fz-14-px">
                        {{ 'companies.lblProvidersOnly' | translate }}
                    </span>
                </div>
                <hr class="line-h-blue-purple-dialogs">
            </div>
            <div class="row">
                <div class="col-lg-12">

                    <ng-container *ngFor="let section of catProvidersSections">

                        <div class="form-group">
                            <div class="alert alert-gray" role="alert">
                                <span class="lbl-form">
                                    {{ "companies.providers."+section.name | translate }}
                                </span>
                            </div>
                        </div>
                        <br>

                        <ng-container *ngFor="let provider of listProviders">

                            <ng-container *ngIf="section.id === provider.type">

                                <div class="radio-group">
                                    <input type="radio" name="clasificacionActual{{provider.type}}" id="provider{{provider.providerId}}" [checked]="provider.enabled" [disabled]="true"> &nbsp;{{ provider.description }}
                                </div>

                                <br>

                            </ng-container>

                        </ng-container>

                    </ng-container>

                </div>
            </div>
        </div>
    </ng-container>

    <br><br><br>

</div>

<div class="modal-footer position-sticky">
    <button class="btn btn-secondary " data-dismiss="modal" (click)="onClose()">
        {{'common.btnClose' | translate }}
    </button>
</div>
